// Shared by Login, Signup and OTP pages: form on the left, product visual on the right.
// footerLeft: small text/link at the bottom left, e.g. "Have an account? Sign in"
const week = [
  ["Sun", 42],
  ["Mon", 58],
  ["Tue", 51],
  ["Wed", 73],
  ["Thu", 66],
  ["Fri", 49],
  ["Sat", 31],
];
const peak = Math.max(...week.map(([, n]) => n));

const AuthLayout = ({ footerLeft, children }) => (
  <div className="flex min-h-screen items-stretch justify-center bg-canvas font-sans text-ink min-[900px]:items-center min-[900px]:p-6">
    <div className="grid min-h-screen w-full max-w-[1180px] grid-cols-1 overflow-hidden bg-gradient-to-br from-fog to-butter min-[900px]:min-h-[700px] min-[900px]:grid-cols-[1fr_1.05fr] min-[900px]:rounded-[36px] min-[900px]:shadow-[0_30px_80px_-30px_rgba(31,29,24,0.45)]">
      <main className="flex flex-col px-[22px] pb-5 pt-6 min-[900px]:px-14 min-[900px]:pb-7 min-[900px]:pt-10">
        <header>
          <span className="inline-block rounded-full border border-ink/30 px-5 py-1.5 font-display text-[1.3rem] font-bold tracking-[-0.01em]">
            vnoirs
          </span>
        </header>

        <div className="mx-auto my-auto w-full max-w-[420px] py-8">
          {children}
        </div>

        <footer className="flex items-center justify-between gap-4 text-[0.88rem] text-muted">
          <span>{footerLeft}</span>
          <span>© {new Date().getFullYear()} Vnoirs</span>
        </footer>
      </main>

      {/* Product visual (decorative) */}
      <aside
        aria-hidden="true"
        className="m-4 ml-0 hidden flex-col justify-between gap-8 overflow-hidden rounded-[28px] bg-char bg-[radial-gradient(circle_at_25%_15%,#4d4533,#2a2722_65%)] p-8 text-white min-[900px]:flex"
      >
        {/* stacked order cards */}
        <div className="relative h-[132px] max-w-[300px]">
          <div className="absolute left-0 right-[-16px] top-[60px] rounded-2xl bg-white/10 px-4 pb-3 pt-9 text-[0.85rem] text-white/80">
            Courier booked · 09:30 am
          </div>
          <div className="relative z-10 rounded-2xl bg-brand px-4 py-3.5 text-ink">
            <div className="flex items-start justify-between gap-3">
              <span className="font-semibold">
                Order #4821 is out for delivery
              </span>
              <span className="mt-1.5 h-2 w-2 flex-none rounded-full bg-ink" />
            </div>
            <span className="text-[0.82rem]">Cash on delivery · 02:30 pm</span>
          </div>
        </div>

        {/* week of orders */}
        <div className="rounded-2xl bg-white/10 p-4 backdrop-blur-sm">
          <p className="m-0 mb-3 text-[0.85rem] text-white/70">
            Orders this week
          </p>
          <div className="grid grid-cols-7 gap-2 text-center">
            {week.map(([day, n]) => (
              <div key={day} className="flex flex-col items-center gap-1">
                <div className="flex h-16 items-end">
                  <span
                    className={`w-2.5 rounded-full ${n === peak ? "bg-brand" : "bg-white/40"}`}
                    style={{ height: `${(n / peak) * 100}%` }}
                  />
                </div>
                <span className="text-[0.8rem] text-white/70">{day}</span>
                <span className="text-[0.95rem] font-semibold">{n}</span>
              </div>
            ))}
          </div>
        </div>

        {/* whatsapp update */}
        <div className="w-full max-w-[340px] rounded-2xl bg-white p-5 text-ink">
          <div className="flex items-start justify-between gap-3">
            <span className="font-semibold">WhatsApp update sent</span>
            <span className="mt-1.5 h-2 w-2 flex-none rounded-full bg-ok" />
          </div>
          <span className="text-[0.85rem] text-muted">
            To 120 customers · 12:00 pm
          </span>
        </div>
      </aside>
    </div>
  </div>
);

export default AuthLayout;
